export enum ProposalsRoles {
  VIEWER = 'roles.proposalsViewer',
  PERSISTER_SENDER = 'roles.proposalsPersisterSender',
  MANAGER = 'roles.proposalsManager',

  EXPIRES_IN_DAYS_EDITOR = 'roles.proposalsExpiresInDaysEditor',
  REFERENCE_EDITOR = 'roles.proposalsReferenceEditor',
}
